var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.04004C5.925 1.04004 1 5.96504 1 12.04C1 18.115 5.925 23.04 12 23.04C18.075 23.04 23 18.115 23 12.04C23 5.96504 18.075 1.04004 12 1.04004ZM11.5 6.04004C11.2348 6.04004 10.9804 6.1454 10.7929 6.33293C10.6054 6.52047 10.5 6.77482 10.5 7.04004C10.5 7.30526 10.6054 7.55961 10.7929 7.74715C10.9804 7.93468 11.2348 8.04004 11.5 8.04004H12C12.2652 8.04004 12.5196 7.93468 12.7071 7.74715C12.8946 7.55961 13 7.30526 13 7.04004C13 6.77482 12.8946 6.52047 12.7071 6.33293C12.5196 6.1454 12.2652 6.04004 12 6.04004H11.5ZM10 10.04C9.73478 10.04 9.48043 10.1454 9.29289 10.3329C9.10536 10.5205 9 10.7748 9 11.04C9 11.3053 9.10536 11.5596 9.29289 11.7471C9.48043 11.9347 9.73478 12.04 10 12.04H11V15.04H10C9.73478 15.04 9.48043 15.1454 9.29289 15.3329C9.10536 15.5205 9 15.7748 9 16.04C9 16.3053 9.10536 16.5596 9.29289 16.7471C9.48043 16.9347 9.73478 17.04 10 17.04H14C14.2652 17.04 14.5196 16.9347 14.7071 16.7471C14.8946 16.5596 15 16.3053 15 16.04C15 15.7748 14.8946 15.5205 14.7071 15.3329C14.5196 15.1454 14.2652 15.04 14 15.04H13V11.04C13 10.7748 12.8946 10.5205 12.7071 10.3329C12.5196 10.1454 12.2652 10.04 12 10.04H10Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.d1ed2abf301d50ee672d5894b3fa05ef.svg";
export { ForwardRef as ReactComponent };